import type { KeyEventArgs } from "./events.js";

/**
 * Keys that scroll or navigate the host page if the canvas lets them through.
 */
const PAGE_KEYS = new Set([
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "PageUp",
  "PageDown",
  "Home",
  "End",
  " ",
  "Backspace",
]);

/**
 * Whether the Desktop should call preventDefault on a key the focused control
 * did not handle.
 *
 * `editing` is true while a control that consumes printable keystrokes has
 * focus. Suppression must be off in that case: text reaches Webwin through the
 * `input` event the browser raises on the hidden field, and preventing the
 * default stops the browser inserting the character at all. Space is the one
 * that bites — it is both a page-scroll key and a perfectly ordinary character.
 */
export function shouldSuppressKey(args: KeyEventArgs, editing: boolean): boolean {
  if (editing) return false;
  return PAGE_KEYS.has(args.key);
}
